import React from 'react';
import { Link } from 'react-router-dom';

/* =====================================================================
   RichText — blog ve SSS metinlerindeki satır içi işaretleri çözer:
     **kalın**        → <strong>
     [metin](/yol)    → iç link (react-router Link)
     [metin](https:…) → harici link, yeni sekmede
     [metin](mailto:…) / (tel:…) → aynı sekmede düz link
   ===================================================================== */

const TOKEN = /\*\*(.+?)\*\*|\[(.+?)\]\((.+?)\)/g;
const LINK_CLASS =
  'font-medium text-brand-700 underline decoration-brand-300 underline-offset-2 hover:decoration-brand-600';

const RichText = ({ text }) => {
  const parts = [];
  let last = 0;
  for (const m of text.matchAll(TOKEN)) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    const key = m.index;
    if (m[1]) {
      parts.push(
        <strong key={key} className="font-semibold text-ink-strong">
          {m[1]}
        </strong>
      );
    } else if (m[3].startsWith('/')) {
      parts.push(
        <Link key={key} to={m[3]} className={LINK_CLASS}>
          {m[2]}
        </Link>
      );
    } else if (/^(mailto|tel):/.test(m[3])) {
      parts.push(
        <a key={key} href={m[3]} className={LINK_CLASS}>
          {m[2]}
        </a>
      );
    } else {
      parts.push(
        <a key={key} href={m[3]} target="_blank" rel="noopener noreferrer" className={LINK_CLASS}>
          {m[2]}
        </a>
      );
    }
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return <>{parts}</>;
};

export default RichText;
